<!-- <button (click)="switchLanguage('en')">English</button>
<button (click)="switchLanguage('fr')">Français</button>


<h1>{{ 'HELLO' | translate }}</h1>
<p>{{ 'WELCOME' | translate }}</p> -->

<router-outlet></router-outlet>
